<template>

<collapsible-panel v-if="activeSection != 'new'" :external-toggle="panelOpen" :always-open="panelOpen" panel-size="sm">
	<template slot="panel">
		<panel-menu 
			:menu-items="sections"
			:active-item="activeSection"
			v-on:itemClick="activateSection">
		</panel-menu>
	</template>
	<template slot="main">
		<draw-breakdown v-if="activeSection == 'Schedule of Values'"></draw-breakdown>

		<project-invoices v-else
			v-on:invoiceOpened="panelOpen = false"
			v-on:invoiceClosed="invoiceClosed">
		</project-invoices>
		
	</template>
</collapsible-panel>

</template>
<script type="text/javascript">
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"

import DrawBreakdown from "./invoicing/DrawBreakdown"
import ProjectInvoices from "./invoicing/ProjectInvoices"

//import HeadingWidget from "@/components/HeadingWidget"
import JobMixins from "@/mixins/JobMixins.js"

export default {
	name: "ProjectBilling",
	components: {
		CollapsiblePanel,
		PanelMenu,
		DrawBreakdown,
		ProjectInvoices
	},
	mixins: [JobMixins],
	data() {
		return {
			activeSection: "",
			panelOpen: true,
			sections: [
				"Schedule of Values",
				"Invoices"
			],
		}
	},
	methods: {
		activateSection(item) {
			this.activeSection = item
			//window.history.pushState({},"","/project/"+this.$route.params.id+"/billing/"+item.slugify())
			this.$router.push("/project/"+this.$route.params.id+"/billing/"+item.slugify())
		},
		invoiceClosed() {
			this.panelOpen = true
			this.activeSection = "Invoices"
		},
		fetchData() {
			let vm = this


			let promises = [
				
			]

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)
				
			})
		}
	},
	created() {
		this.fetchData()

		if ("tag" in this.$route.params && this.$route.params.tag) {
			//set active tag
			this.activeSection = this.sections.find(section => section.slugify() == this.$route.params.tag)	
		}

	}
}
</script>